import React, { useEffect } from 'react';
import styled from 'styled-components';
import {
  WidgetPrintHeader,
  Container,
  BodyPrint,
} from '@mummssoftware/common-ui';
import { PatientsListingTable } from '../PatientsListing/PatientsListingTable';

// way to get next page break with global printing
const PageBreak = styled.div`
  @media print {
    visibility: hidden;
  }
`;

type PatientsListingPrintProps = {
  patientsList: mumms.patient[];
  onWidgetReady?: (arg: mumms.ComponentName) => void;
};
export const PatientsListingPrint = (props: PatientsListingPrintProps) => {
  const { onWidgetReady } = props;

  // on component did mount
  useEffect(() => {
    // callback to alert dashboard the view is ready
    onWidgetReady && onWidgetReady('PatientsListing' as mumms.ComponentName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <BodyPrint>
        <WidgetPrintHeader title="patientsList" />
        <PatientsListingTable viewModePrint />
      </BodyPrint>
      <PageBreak />
    </Container>
  );
};

export default PatientsListingPrint;
